import React, { useEffect, useRef, useState } from 'react';
import { Task } from 'make-traffic-integration-core';
import { dispatchModalToggle } from '@make-software/tg-mini-app-ui';

import {
  BaseModal,
  isStandalonePWA,
  markInstallToHomeScreenCompleted,
  TaskContent,
  useMakeTrafficManager,
  WALLET_MODAL_EVENT
} from '@/shared';
import { TaskCustomMetadata } from '@/entities';

export const TaskModal = () => {
  const makeTrafficManager = useMakeTrafficManager();
  const [drawerMakeTrafficTask, setDrawerMakeTrafficTask] = useState<Task | null>(null);
  const hasStartedTaskRef = useRef(false);

  useEffect(() => {
    if (makeTrafficManager?.selectedTask) {
      setDrawerMakeTrafficTask(makeTrafficManager.selectedTask);
    } else {
      setDrawerMakeTrafficTask(null);
    }
  }, [makeTrafficManager?.selectedTask]);

  const closeDrawer = () => {
    if (hasStartedTaskRef.current) {
      makeTrafficManager.refreshTaskList();
      hasStartedTaskRef.current = false;
    }
    setDrawerMakeTrafficTask(null);
    makeTrafficManager.handleSelectTask(null);
  };

  const startMakeTrafficTask = async () => {
    if (!makeTrafficManager.selectedTask) return;
    const meta = makeTrafficManager.selectedTask.customMetadata as TaskCustomMetadata;
    if (meta?.action === 'connect_wallet') {
      closeDrawer();
      dispatchModalToggle(WALLET_MODAL_EVENT, { open: true });
      return;
    }
    if (meta?.action === 'install_to_home_screen') {
      closeDrawer();
      dispatchModalToggle('install_to_home_screen', { open: true });
      return;
    }
    hasStartedTaskRef.current = true;
    await makeTrafficManager.processSelectedTask();
  };

  const completeMakeTrafficTask = async () => {
    if (!makeTrafficManager.selectedTask) return;
    const meta = makeTrafficManager.selectedTask.customMetadata as TaskCustomMetadata;
    hasStartedTaskRef.current = false;
    closeDrawer();

    try {
      if (meta?.action === 'install_to_home_screen' && isStandalonePWA()) {
        await markInstallToHomeScreenCompleted();
      }
      await makeTrafficManager.claimSelectedTask();
    } catch (error) {
      console.error('Error claiming task:', error);
    }
  };

  const isOpen = Boolean(drawerMakeTrafficTask);

  return (
    <BaseModal
      onRequestClose={closeDrawer}
      shouldCloseOnEsc
      closeTimeoutMS={300}
      shouldCloseOnOverlayClick
      isOpen={isOpen}
      variant="bottom-sheet"
      style={{
        content: {
          inset: 'auto 0 0 0',
          padding: '0 0 20px 0',
          boxShadow: 'inset 0 0 0 1px #41424E',
          top: 'auto',
          maxWidth: '640px'
        }
      }}
    >
      {drawerMakeTrafficTask && (
        <TaskContent
          drawerTask={drawerMakeTrafficTask}
          onClearDrawer={closeDrawer}
          onStartTask={startMakeTrafficTask}
          onClaimTask={completeMakeTrafficTask}
        />
      )}
    </BaseModal>
  );
};
